import { render, staticRenderFns } from "./MAM_transferTerminal.vue?vue&type=template&id=191e96cb&scoped=true&"
import script from "./MAM_transferTerminal.vue?vue&type=script&lang=js&"
export * from "./MAM_transferTerminal.vue?vue&type=script&lang=js&"
import style0 from "./MAM_transferTerminal.vue?vue&type=style&index=0&id=191e96cb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191e96cb",
  null
  
)

export default component.exports